export default __webpack_public_path__ + "static/media/07.dad90a5e.png";